<template>
  <div class="home">
    <HeaderBar title="诊疗方案"></HeaderBar>
    <div class="center-box-no-footer">
      <van-collapse v-model="activeNames">
        <van-collapse-item v-for="(item,index) in tableData" :key="index" title="标题1" :name="index">
          <template #title>
            <div class="item-title">{{item.bd002002}}</div>
          </template>
          <FormNormalInput label="药物类型" v-model="item.bd001002" readonly />
          <FormNormalInput label="规格" v-model="item.bq403004" readonly />
          <FormNormalInput label="给药途径" v-model="item.bq403006" readonly />
          <FormNormalInput label="用法" v-model="item.bq403010" readonly />
          <FormNormalInput label="用量" v-model="item.bq403008Name" readonly />
          <FormNormalInput label="开始用药" v-model="item.bq403014" readonly />
          <FormNormalInput label="停药时间" v-model="item.bq4030152" readonly />
          <FormNormalInput label="停药说明" v-model="item.bq4030153" readonly />
          <FormNormalInput label="备注" v-model="item.bq403012" readonly />
        </van-collapse-item>
      </van-collapse>
    </div>
  </div>
</template>

<script>
  // 引入服务组件
  import componentsModel from '../../base/components.js'

  export default {
    name: "page",
    data() {
      return {
        typeList: [],
        leftActive: 0,
        showPage: "page001",
        bq400: JSON.parse(sessionStorage.getItem('bq400')), //获取随访信息
        tableData: [],
        activeNames: [0],
      }
    },
    components: {
      ...componentsModel,

    },
    methods: {
      //加载信息,获取所有用药记录
      LoadInfo: function() {
        var that = this
        var condition = {
          currentPage: 1,
          pageSize: 10000,
          recordCount: 0,
          bq400guid: that.bq400.guid //当前随访编号
        }
        that.$utils.HttpPost(this.$utils.Url.s400 + '/api/S400Bq403/AllList', condition, function(d) {
          let dataList = d.data
          dataList.forEach(function(item) {
			  that.$utils.CopyKeyInfo(item,item)
            item.bq403008Name = item.bq403008 + item.bq4030082
          })
          that.tableData = d.data
        }, null, null, null);
      },
    },
    mounted() {
      let that = this
      // that.form.bq403.bq400guid = that.bq400.guid
      that.LoadInfo()
    }
  }
</script>

<style scoped>
  .physical-check-box {
    background-color: #fff;
    display: flex;
  }



  .setting-left {
    width: 210px;
    box-sizing: border-box;
  }

  .left-item {
    width: 100%;
    box-sizing: border-box;
    font-size: 14px;
    color: #666666;
    letter-spacing: 0;
    height: 40px;
    line-height: 40px;
    padding-right: 20px;
    padding-left: 30px;
    cursor: pointer;
    border-right: 1px solid #ccc;

  }

  .left-item.active {
    border: 1px solid #ccc;
    border-left: 4px solid var(--color);
    border-radius: 2px;
    border-right: none;
    /* background-color: var(--color); */
    color: var(--color);
  }

  .left-item:first-child.active {
    border-top: none;
  }

  .setting-right {
    flex: 1;
    box-sizing: border-box;
    padding-left: 30px;
    padding-top: 30px;
    display: flex;
  }

  .setting-right-content {
    width: 100%;
  }

  .setting-right .setting-right-image {
    flex: 1;
    height: 600px;
    overflow-y: auto;
    /* height: 200px; */
    /* border: 1px solid #ccc; */
    padding: 0 20px 20px 20px;
  }

  /deep/.form-row .form-item .form-item-left {
    width: 220px;
    display: flex;
    justify-content: flex-end;
    padding-right: 20px;
    box-sizing: border-box;
    font-size: 14px;
    color: #333333;
    line-height: 14px;
  }
</style>
